/** Utilitários CSR mTLS Cielo — geração no servidor (xpro4api). */

export const CIELO_PIX_MTLS_SUPPORT_EMAIL = "apipix.suporte@cielo.com.br";

export function slugifyCieloMtlsPartnerName(raw) {
  const s = String(raw || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9]+/g, "")
    .toLowerCase();
  return (s || "").slice(0, 48);
}

export function buildCieloMtlsCommonName(partnerSlug) {
  const slug = slugifyCieloMtlsPartnerName(partnerSlug);
  return slug ? `api-${slug}-mtls` : "";
}

/**
 * Nome do parceiro para o CN — prioriza dados já cadastrados no Xpro.
 */
export function deriveCieloMtlsPartnerSlug({
  companies = [],
  projectId = null,
  workspaceCompanySlug = "",
  paymentMethodName = "",
  idInterno = "",
} = {}) {
  const pickName = (c) =>
    c?.nome || c?.fantasia || c?.razao_social || c?.name || "";

  const pid = projectId != null && projectId !== "" ? Number(projectId) : null;
  if (pid && Number.isFinite(pid) && pid > 0) {
    const byProject = companies.find((c) => Number(c.id) === pid);
    const fromProject = slugifyCieloMtlsPartnerName(pickName(byProject));
    if (fromProject.length >= 2) return { slug: fromProject, source: "project" };
  }

  const ws = String(workspaceCompanySlug || "").trim().toLowerCase();
  if (ws && companies.length) {
    const bySlug = companies.find((c) => {
      const keys = [
        c.slug,
        c.chave,
        c.domain,
        c.company,
        c.identificador,
      ]
        .filter(Boolean)
        .map((x) => String(x).trim().toLowerCase());
      return keys.includes(ws);
    });
    const fromWs = slugifyCieloMtlsPartnerName(pickName(bySlug));
    if (fromWs.length >= 2) return { slug: fromWs, source: "workspace" };
  }

  const nomePm = String(paymentMethodName || "").trim();
  if (nomePm && !/^pix(\s|cielo)?$/i.test(nomePm)) {
    const fromNome = slugifyCieloMtlsPartnerName(nomePm);
    if (fromNome.length >= 2) return { slug: fromNome, source: "paymentMethodName" };
  }

  const idInt = slugifyCieloMtlsPartnerName(idInterno);
  if (idInt.length >= 2) return { slug: idInt, source: "idInterno" };

  return { slug: "", source: null };
}

export function buildCieloMtlsMailto(partnerSlug) {
  const cn = buildCieloMtlsCommonName(partnerSlug);
  const subject = encodeURIComponent(`Pedido certificado mTLS Pix — ${cn || "loja"}`);
  const body = encodeURIComponent(
    `Prezados,\n\n` +
      `Segue em anexo o arquivo certificado.csr para emissão do certificado mTLS (API Pix).\n\n` +
      (cn ? `Identificador (CN): ${cn}\n\n` : "") +
      `Atenciosamente.`
  );
  return `mailto:${CIELO_PIX_MTLS_SUPPORT_EMAIL}?subject=${subject}&body=${body}`;
}

export function downloadTextFile(filename, text, mimeType = "application/x-pem-file") {
  const blob = new Blob([text], { type: `${mimeType};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
